import { ConsumerLoanTargetPath } from '../domain/types';
import { IFieldState } from '../store/applicationform/applicationFormTypes';
import { AuthenticationData } from '../store/authentication';
import { CountryCode } from '../types/CountryCode';
import { LanguageCode } from '../types/LanguageCode';
import { apiClient } from './apiClient';
import { Debt } from './getDebts';
import { SubmitApplicationResponse } from './submitApplication';
import { callbackUrl, dataFormPage } from './util';

export const createSubmitPayload = (
    applicationId: string,
    languageCode: string,
    countryCode: string,
    formFieldsInput: IFieldState[],
    consentFieldsInput: IFieldState[],
    consolidations: Debt[],
    kycTemplateVersion?: number,
) => {
    return {
        ...dataFormPage({ applicationId }, formFieldsInput, consentFieldsInput),
        callbackUrl: callbackUrl(ConsumerLoanTargetPath.callback, languageCode, countryCode, ''),
        applicationUrl: callbackUrl(ConsumerLoanTargetPath.coapplicant, languageCode, countryCode, ''),
        consolidations: consolidations ?? [],
        kycTemplateVersion,
    };
};

export const submitCoApplicantService = async (
    apiProxyPath: string,
    languageCode: LanguageCode,
    countryCode: CountryCode,
    apiKey: string,
    authenticationData: AuthenticationData,
    applicationId: string,
    formFieldsInput: IFieldState[],
    consentFieldsInput: IFieldState[],
    arn: string | undefined,
    consolidations: Debt[],
    kycTemplateVersion?: number,
): Promise<SubmitApplicationResponse> => {
    return apiClient<SubmitApplicationResponse>(`${apiProxyPath}/application/${arn}/co-applicant`, {
        method: 'PUT',
        body: createSubmitPayload(
            applicationId,
            languageCode,
            countryCode,
            formFieldsInput,
            consentFieldsInput,
            consolidations,
            kycTemplateVersion,
        ),
        apiKey,
        authenticationData,
        sentryTag: 'submit_co_applicant',
        sentryExtra: { arn, countryCode, languageCode },
    });
};
